import { DEV } from 'solid-js'
import { InferOutput, nullable, optional, variant } from 'valibot'
import { deepClone } from '../../deep_clone'
import { entitySchemaList } from './entityTypeMetaList.generated'

const INVALID_ETYPE_ID_MESSAGE = 'Invalid EntityTypeId'

/**
 * Entity Union
 */
export const EntitySchema = variant('etype_id', entitySchemaList, (DEV ? (issue) => {
  console.error('EntitySchema Issue', deepClone(issue))
  console.error('EntitySchema Entity', deepClone(issue.path?.at(-1)?.input))
  return INVALID_ETYPE_ID_MESSAGE
} : INVALID_ETYPE_ID_MESSAGE))

export type Entity = InferOutput<typeof EntitySchema>

export const NullableEntitySchema = nullable(EntitySchema)

export type NullableEntity = InferOutput<typeof NullableEntitySchema>

export const OptionalNullableEntitySchema = optional(NullableEntitySchema)

export type OptionalNullableEntity = InferOutput<typeof OptionalNullableEntitySchema>
